import React from "react";

import Menu from "./Menu";

const Header = (props) => {
  return (
    <>
      <div className="header">
        <div className="container">
          <div className="title">
            <h1>Rettungsdienst Bremen</h1>
            <p>Fahrzeugverwaltung (Version 0.1.26)</p>
          </div>
          <div className="logo"></div>
        </div>
      </div>
      <Menu
        page={props.page}
        changePage={props.changePage}
        searchString={props.searchString}
        setSearchString={props.setSearchString}
        neueMaengel={props.neueMaengel}
      />
    </>
  );
};

export default Header;
